export enum NotificationType {
    Alert = 0,
    Message = 1,
    Warning = 2,
    SuccessMessage = 3,
}